import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { IntentProject } from "types/generated";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import DropdownMenuEllipsis from "ds/components/DropdownMenu/Ellipsis";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import CopyFieldDropdownMenuItem from "components/CopyField/DropdownMenuItem";
import useDeleteIntentProject from "shared/IntentProject/useDeleteIntentProject";
import useUnlockIntentProject from "shared/IntentProject/useUnlockIntentProject";
import useTypedFlags from "hooks/useTypedFlags";
import useIntentProjectDownloadHcl from "shared/IntentProject/useDownloadHcl";
import useCanUpdateIntentProject from "shared/IntentProject/access/useCanUpdateIntentProject";
import useCanDeleteIntentProject from "shared/IntentProject/access/useCanDeleteIntentProject";
import useCanUnlockIntentProject from "shared/IntentProject/access/useCanUnlockIntentProject";

import { showCreateIntentProjectDrawer } from "../../CreateIntentProjectDrawer";

const IntentProjectsTableRowActionsCell = ({
  item: intentProject,
  ...cellProps
}: TableSimpleCellProps<IntentProject>) => {
  const { intentToIac } = useTypedFlags();

  const { deleteIntentProject, loading } = useDeleteIntentProject();
  const { unlockIntentProject, loading: unlockLoading } = useUnlockIntentProject();
  const { downloadHcl, loading: downloadHclLoading } = useIntentProjectDownloadHcl();

  const canUpdateIntentProject = useCanUpdateIntentProject()(intentProject.space.id);
  const canDeleteIntentProject = useCanDeleteIntentProject()(intentProject.space.id);
  const canUnlockIntentProject = useCanUnlockIntentProject()(intentProject.space.id);

  const handleEdit = () => {
    showCreateIntentProjectDrawer({
      project: intentProject,
    });
  };

  const handleDelete = () => {
    deleteIntentProject(intentProject.id);
  };

  const handleUnlock = () => {
    unlockIntentProject(intentProject.id);
  };

  const handleDownloadHcl = () => {
    downloadHcl(intentProject.id);
  };

  return (
    <TableSimpleCell {...cellProps}>
      <DropdownMenuEllipsis tooltip="Intent Project actions">
        <DropdownMenuItem
          onAction={handleEdit}
          isDisabled={!canUpdateIntentProject.result}
          tooltip={canUpdateIntentProject.message}
          tooltipPlacement="left"
        >
          Edit
        </DropdownMenuItem>
        <CopyFieldDropdownMenuItem title="Copy ID" value={intentProject.id} />
        {intentToIac && (
          <DropdownMenuItem onAction={handleDownloadHcl} isDisabled={downloadHclLoading}>
            Download HCL file(s)
          </DropdownMenuItem>
        )}
        {intentProject.lockedBy && (
          <DropdownMenuItem
            onAction={handleUnlock}
            isDisabled={unlockLoading || !canUnlockIntentProject.result}
            tooltip={canUnlockIntentProject.message}
            tooltipPlacement="left"
          >
            Unlock
          </DropdownMenuItem>
        )}
        <DropdownMenuItem
          onAction={handleDelete}
          danger
          isDisabled={loading || !canDeleteIntentProject.result}
          tooltip={canDeleteIntentProject.message}
          tooltipPlacement="left"
        >
          Delete
        </DropdownMenuItem>
      </DropdownMenuEllipsis>
    </TableSimpleCell>
  );
};

export default IntentProjectsTableRowActionsCell;
